import React from 'react'

const Titles = () =>
{
  return (
    <div className='flex flex-col items-center justify-center'>
        <p className='text-slate-50 font-serif opacity-80 text-2xl sm:text-xl'>Developer</p>
        <p className='text-slate-50 font-serif opacity-80 text-2xl sm:text-xl'>Designer</p>
        <p className='text-slate-50 font-serif opacity-80 text-2xl sm:text-xl'>Dreamer</p>
    </div>
  )
}

export default Titles